const API_URL = process.env.REACT_APP_API_URL

let logoutCallback = null;

export function setLogoutCallback(fn) {
  logoutCallback = fn;
}

export async function fetchWithAuth(url, options = {}) {
  let token = localStorage.getItem("token");
  let refresh = localStorage.getItem("refresh");
  let headers = {
    ...options.headers,
    Authorization: token ? `Bearer ${token}` : undefined,
    "Content-Type": "application/json",
  };

  let resp = await fetch(url, { ...options, headers });

  if (resp.status === 401 || resp.status === 403) {
    if (refresh) {
      const refreshResponse = await fetch(`${API_URL}/api/token/refresh/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refresh }),
      });

      if (refreshResponse.ok) {
        const data = await refreshResponse.json();
        const newToken = data.access;
        localStorage.setItem("token", newToken);

        headers.Authorization = `Bearer ${newToken}`;
        resp = await fetch(url, { ...options, headers });
        if (resp.status !== 401 && resp.status !== 403) {
          return resp;
        }
      }
    }

    if (logoutCallback) { logoutCallback(); }
    throw new Error("Session expirée");
  }

  return resp;
}